import json from "../json/cdn/jmisSsl.json";

export default async () => JSON.parse(JSON.stringify(await json));
